import "./Team.css";

const team = [
  { name:"Riza Fadlyrrofi",  role:"Chief Executive Officer",  img:"https://plus.unsplash.com/premium_photo-1664536392896-cd1743f9c02c?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=300&auto=format&fit=crop" },
  { name:"Alfi Alfi", role:"Project Manager", img:"https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=300&auto=format&fit=crop" },
  { name:"Ahid Arief",    role:"Client Relationship Manager",      img:"https://plus.unsplash.com/premium_photo-1671656349322-41de944d259b?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=300&auto=format&fit=crop" },
  { name:"Muhammad Richo",     role:"Digital Transformation Lead",  img:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=300&auto=format&fit=crop" },
];

export default function Team() {
  return (
    <section className="team">
      <div className="container">
        <div className="team__head">
          <div>
            <span className="eyebrow">Tim Kami</span>
            <h2 className="team__title">Kenalkan Ahli Taman &amp; Pohon Kami</h2>
          </div>
          <p className="team__sub">
            Tim kami terdiri dari para profesional berpengalaman yang berdedikasi tinggi pada setiap proyek penghijauan.
          </p>
        </div>

        <div className="team__grid">
          {team.map(m => (
            <div className="team-card" key={m.name}>
              <div className="team-card__img">
                <img src={m.img} alt={m.name} />
                <div className="team-card__overlay">
                  <div className="team-card__socials">
                    <span>🌿</span>
                    <span>📧</span>
                    <span>🔗</span>
                  </div>
                </div>
              </div>
              <div className="team-card__info">
                <h4>{m.name}</h4>
                <span>{m.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
